var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-switch',_vm._b({ref:_vm.$attrs.name || 'switch',class:{
    big: _vm.size === 'big',
    medium: _vm.size === 'medium',
    small: _vm.size === 'small',
    'is-focused': _vm.focused
  },attrs:{"active-color":_vm.activeColor,"inactive-color":_vm.inactiveColor,"disabled":_vm.disabled},on:{"change":value => _vm.$emit('switch', value)},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'el-switch',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }